import {
  Box,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select as MuiSelect,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import FieldLoader from "../Atom/FieldLoader";

export default function Select(props) {
  const { t } = useTranslation();
  const properties = {
    ...props,
    label: t(`FORM.FIELD.${props.name}`),
  };

  const {
    width,
    required,
    error,
    helperText,
    options,
    disabled,
    sx,
    name,
    label,
    value,
    variant,
    onChange,
  } = properties;
  return (
    <FormControl
      variant={variant || "outlined"}
      sx={{
        width: width || "100%",
        ...sx,
      }}
      required={required}
      {...(error && { error: true })}
      {...((disabled || options.length === 0) && { disabled: true })}
    >
      <>
        <InputLabel>
          {<span style={{ fontWeight: "bold" }}>{label}</span>}
        </InputLabel>
        <MuiSelect
          label={<span style={{ fontWeight: "bold" }}>{label}</span>}
          name={name}
          value={value}
          onChange={onChange}
          {...((disabled || options.length === 0) && { disabled: true })}
        >
          {options.map((item, i) => (
            <MenuItem key={i} value={item.value}>
              {t(`FORM.OPTIONS.${item.label}`, item.label)}
            </MenuItem>
          ))}
        </MuiSelect>
      </>

      {options.length === 0 && (
        <Box
          display={"flex"}
          justifyContent={"center"}
          paddingTop={1}
          height={"100%"}
          width={"100%"}
          position={"absolute"}
        >
          <FieldLoader />
        </Box>
      )}

      {error && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
}
